// Resolve a product photo into a usable browser URL.
// Supports:
//  - Absolute URLs (http/https)
//  - Backend-relative uploads (/api/uploads/...)
//  - Site-relative paths (/brand/...)
//  - Bare filenames (legacy static catalog) → /brand/products/<file>
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function photoUrl(photo) {
  if (!photo) return "/brand/products/placeholder.jpg";
  if (photo.startsWith("data:")) return photo;
  if (photo.startsWith("http://") || photo.startsWith("https://")) return photo;
  if (photo.startsWith("/api/")) return `${BACKEND}${photo}`;
  if (photo.startsWith("/")) return photo;
  return `/brand/products/${photo}`;
}
